import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { getOrderTotalPrice } from 'store/updateTicketing';
import { getCopy } from 'utils/copy';
import s from 'components/shared/theaters/ticketing/ticketReview/ticketReview.sss';
import bb from 'components/shared/theaters/ticketing/bottomBar.sss';


export default class TicketReview extends Component {

	///////////////////////
	//// CLICK HANDLERS ///
	///////////////////////

	goToNext() {
		Store.emit(actions.GO_TICKETING_CONTACT_DETAILS);
	}

	///////////////////////
	//// RENDER METHODS ///
	///////////////////////

	render(props) {
		const {
			ticketing, // Object - the ticketing state
			currencyCopy = 'CURRENCY'
		} = props;

		// TODO: Bring in seats as prop and set as variable
		const seats = false;

		return (
			<div>
				<div class={s.container}>
					{seats}
				</div>
				<div class={bb.wrapper}>
					<div class={bb.info}>
						<div class={bb.total}>
							{getCopy('TOTAL', {}, 'Total')}
							<span class={bb.totalAmount}>{getCopy(currencyCopy, { value: getOrderTotalPrice() })}</span>
						</div>
					</div>
					<div class={bb.buttonWrapper}>
						<button class={bb.button} onClick={this.goToNext}>{getCopy('NEXT')}</button>
					</div>
				</div>
			</div>
		);
	}

}
